export const GET_INFO_CALENDAR_STARTED = "GET_INFO_CALENDAR_STARTED"
export const GET_INFO_CALENDAR_SUCCESS = "GET_INFO_CALENDAR_SUCCESS"
export const GET_INFO_CALENDAR_FAILURE = "GET_INFO_CALENDAR_FAILURE"

export const GET_APPOINTMENTS_HOLIDAYS_STARTED = "GET_APPOINTMENTS_HOLIDAYS_STARTED"
export const GET_APPOINTMENTS_HOLIDAYS_SUCCESS = "GET_APPOINTMENTS_HOLIDAYS_SUCCESS"
export const GET_APPOINTMENTS_HOLIDAYS_FAILURE = "GET_APPOINTMENTS_HOLIDAYS_FAILURE"

export const UPDATE_APPOINTMENT_SERVICES_FOR_CALENDAR_STARTED = "UPDATE_APPOINTMENT_SERVICES_FOR_CALENDAR_STARTED"
export const UPDATE_APPOINTMENT_SERVICES_FOR_CALENDAR_SUCCESS = "UPDATE_APPOINTMENT_SERVICES_FOR_CALENDAR_SUCCESS"
export const UPDATE_APPOINTMENT_SERVICES_FOR_CALENDAR_FAILURE = "UPDATE_APPOINTMENT_SERVICES_FOR_CALENDAR_FAILURE"

export const GET_WEEK_APPOINTMENTS_HOLIDAYS_FOR_CALENDAR_STARTED = "GET_WEEK_APPOINTMENTS_HOLIDAYS_FOR_CALENDAR_STARTED"
export const GET_WEEK_APPOINTMENTS_HOLIDAYS_FOR_CALENDAR_SUCCESS = "GET_WEEK_APPOINTMENTS_HOLIDAYS_FOR_CALENDAR_SUCCESS"
export const GET_WEEK_APPOINTMENTS_HOLIDAYS_FOR_CALENDAR_FAILURE = "GET_WEEK_APPOINTMENTS_HOLIDAYS_FOR_CALENDAR_FAILURE"

export const UPDATE_WEEK_APPOINTMENT_SERVICES_FOR_CALENDAR_STARTED = "UPDATE_WEEK_APPOINTMENT_SERVICES_FOR_CALENDAR_STARTED"
export const UPDATE_WEEK_APPOINTMENT_SERVICES_FOR_CALENDAR_SUCCESS = "UPDATE_WEEK_APPOINTMENT_SERVICES_FOR_CALENDAR_SUCCESS"
export const UPDATE_WEEK_APPOINTMENT_SERVICES_FOR_CALENDAR_FAILURE = "UPDATE_WEEK_APPOINTMENT_SERVICES_FOR_CALENDAR_FAILURE"

export const DUPLICATE_APPOINTMENT_FOR_CALENDAR_STARTED = "DUPLICATE_APPOINTMENT_FOR_CALENDAR_STARTED"
export const DUPLICATE_APPOINTMENT_FOR_CALENDAR_SUCCESS = "DUPLICATE_APPOINTMENT_FOR_CALENDAR_SUCCESS"
export const DUPLICATE_APPOINTMENT_FOR_CALENDAR_FAILURE = "DUPLICATE_APPOINTMENT_FOR_CALENDAR_FAILURE"

export const DUPLICATE_SERVICE_FOR_CALENDAR_STARTED = "DUPLICATE_SERVICE_FOR_CALENDAR_STARTED"
export const DUPLICATE_SERVICE_FOR_CALENDAR_SUCCESS = "DUPLICATE_SERVICE_FOR_CALENDAR_SUCCESS"
export const DUPLICATE_SERVICE_FOR_CALENDAR_FAILURE = "DUPLICATE_SERVICE_FOR_CALENDAR_FAILURE"

export const GET_APPOINTMENTS_FOR_DUPLICATE_FOR_CALENDAR_STARTED = "GET_APPOINTMENTS_FOR_DUPLICATE_FOR_CALENDAR_STARTED"
export const GET_APPOINTMENTS_FOR_DUPLICATE_FOR_CALENDAR_SUCCESS = "GET_APPOINTMENTS_FOR_DUPLICATE_FOR_CALENDAR_SUCCESS"
export const GET_APPOINTMENTS_FOR_DUPLICATE_FOR_CALENDAR_FAILURE = "GET_APPOINTMENTS_FOR_DUPLICATE_FOR_CALENDAR_FAILURE"